import visualizationService from "../../services/visualizationService";
import { data, dummyData, dummyData2, sampleFolders } from "./dummyData";
import { initialState } from "./initialState";
import * as types from "./types";
import { errorMessage } from "../../constants/responseMessages";

export const fetchPlot = (payload) => async (dispatch) => {
  dispatch({
    type: types.FETCH_PLOT_STATE,
    payload: {
      loader: true,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });

  try {
    const plotJson = await visualizationService.getPlotData(payload);

    const hasValidData = (plotJson) => {
      if (!plotJson || typeof plotJson !== "object") {
        return false;
      }

      const hasInfo = plotJson?.info !== undefined && plotJson?.info !== null;
      const hasPlotData =
        plotJson?.plot_data !== undefined && plotJson?.plot_data !== null;

      return hasInfo && hasPlotData;
    };

    if (!hasValidData(plotJson)) {
      dispatch({
        type: types.FETCH_PLOT_STATE,
        payload: {
          loader: false,
          error: true,
          message: "Something went wrong while fetching the plot.",
          data: null,
        },
      });
      return plotJson;
    }

    dispatch({
      type: types.FETCH_PLOT_STATE,
      payload: { loader: false, data: plotJson, success: true, error: false },
    });
    return plotJson;
  } catch (err) {
    const msg = errorMessage(err);

    dispatch({
      type: types.FETCH_PLOT_STATE,
      payload: {
        loader: false,
        error: true,
        message: msg,
        data: null,
      },
    });

    return { error: true, message: msg }; // ✅ IMPORTANT
  }
};

export const clearPlot = () => (dispatch) => {
  dispatch({
    type: types.FETCH_PLOT_STATE,
    payload: {
      loader: false,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });
};

let loadedBaseFilterToken = null;
const pendingBaseFilterTokens = new Set();

export const fetchProductsSitesAndUnitOfOperations = (force = false) => async (dispatch, getState) => {
  const token = localStorage.getItem("token");
  if (!token || pendingBaseFilterTokens.has(token)) return;
  const current = getState().viz?.productsAndSitesList;
  if (!force && loadedBaseFilterToken === token && Array.isArray(current?.data)) return;
  pendingBaseFilterTokens.add(token);
  dispatch({
    type: types.FETCH_PRODUCT_SITES_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response =
      await visualizationService.fetchProductsSitesAndUnitOfOperations();
    if (localStorage.getItem("token") !== token) return;
    loadedBaseFilterToken = token;
    dispatch({
      type: types.FETCH_PRODUCT_SITES_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: response.data, // assumes response has `data`
      },
    });
  } catch (error) {
    if (localStorage.getItem("token") !== token) return;
    dispatch({
      type: types.FETCH_PRODUCT_SITES_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  } finally {
    pendingBaseFilterTokens.delete(token);
  }
};

// export const clearProductsSitesAndUnitOfOperations = () => async (dispatch) => {
//   dispatch({
//     type: types.FETCH_PRODUCT_SITES_LIST,
//     payload: {},
//   });
// };

export const fetchParameterList = (payload) => async (dispatch) => {
  dispatch({
    type: types.FETCH_PARAMETER_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await visualizationService.fetchParameterList(payload);
    dispatch({
      type: types.FETCH_PARAMETER_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: response, // assumes response has `data`
      },
    });
  } catch (error) {
    dispatch({
      type: types.FETCH_PARAMETER_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchFilteredBatchList = (payload) => async (dispatch) => {
  dispatch({
    type: types.FETCH_FILTERED_BATCH_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await visualizationService.fetchFilteredBatchList(payload);
    dispatch({
      type: types.FETCH_FILTERED_BATCH_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: response, // assumes response has `data`
      },
    });
    return response;
  } catch (error) {
    dispatch({
      type: types.FETCH_FILTERED_BATCH_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
        data: [],
      },
    });
  }
};

export const clearFilteredBatchList = () => (dispatch) => {
  dispatch({
    type: types.FETCH_FILTERED_BATCH_LIST,
    payload: { ...initialState?.apiStatus },
  });
};

export const clearParameterList = () => (dispatch) => {
  dispatch({
    type: types.FETCH_PARAMETER_LIST,
    payload: { ...initialState?.apiStatus },
  });
};

export const fetchSavedVizList = (requestData) => async (dispatch) => {
  dispatch({
    type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  // dispatch({
  //   type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
  //   payload: {
  //     data: { ...data },
  //   },
  // });
  try {
    const response = await visualizationService.fetchSavedVizList(requestData);
    dispatch({
      type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response,
      },
    });
  } catch (error) {
    dispatch({
      type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
    // dispatch({
    //   type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
    //   payload: {
    //     data: { ...data },
    //   },
    // });
  }
};

export const fetchFolders = (requestData) => async (dispatch) => {
  dispatch({
    type: types.FETCH_FOLDER_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  dispatch({
    type: types.FETCH_FOLDER_REQUEST,
    payload: {
      data: sampleFolders,
    },
  });
  try {
    const response = await visualizationService.getFolders(requestData);
    dispatch({
      type: types.FETCH_FOLDER_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data?.data,
      },
    });
  } catch (error) {
    // dispatch({
    //   type: FETCH_FOLDER_REQUEST,
    //   payload: {
    //     ...initialState.apiStatus,
    //     loader: false,
    //     message: errorMessage(error),
    //     apiError: true,
    //   },
    // });
    dispatch({
      type: types.FETCH_FOLDER_REQUEST,
      payload: {
        data: sampleFolders,
      },
    });
  }
};

export const saveVisualization = (payload) => async (dispatch) => {
  dispatch({
    type: types.SAVE_VIZ_REQUEST,
    payload: {
      loader: true,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });

  try {
    const res = await visualizationService.saveVisualization(payload);
    dispatch({
      type: types.SAVE_VIZ_REQUEST,
      payload: { loader: false, data: res, success: true, error: false },
    });
    return res; // ✅ return result so component can await
  } catch (err) {
    dispatch({
      type: types.SAVE_VIZ_REQUEST,
      payload: {
        loader: false,
        error: true,
        message: errorMessage(err),
        data: null,
      },
    });
    throw err; // ✅ throw error so component can catch
  }
};

export const fetchSavedVisualization = (payload) => async (dispatch) => {
  // dispatch({
  //   type: types.FETCH_SAVED_VIZ_DETAILS,
  //   payload: {
  //     loader: true,
  //     error: false,
  //     message: "",
  //     data: null,
  //     success: false,
  //   },
  // });

  try {
    const data = await visualizationService.fetchSavedVisualization(payload);
    return data;
    // dispatch({
    //   type: types.FETCH_SAVED_VIZ_DETAILS,
    //   payload: {
    //     ...initialState,
    //     loader: false,
    //     data: data,
    //     success: true,
    //     error: false,
    //   },
    // });
  } catch (err) {
    throw err;

    //   dispatch({
    //     type: types.FETCH_SAVED_VIZ_DETAILS,
    //     payload: {
    //       loader: false,
    //       error: true,
    //       message: err.message,
    //       data: null,
    //     },
    //   });
  }
};

export const setViewEditPlotDatToState = (payload) => (dispatch) => {
  dispatch({
    type: types.FETCH_PLOT_STATE,
    payload: { loader: false, data: payload, success: true, error: false },
  });
};

export const getVersionHistoryLogs = (payload) => async (dispatch) => {
  dispatch({
    type: types.GET_VERSION_HISTORY_LOGS,
    payload: {
      loader: true,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });

  try {
    const res = await visualizationService.getVersionHistoryLogs(payload);
    dispatch({
      type: types.GET_VERSION_HISTORY_LOGS,
      payload: { loader: false, data: res, success: true, error: false },
    });
  } catch (err) {
    dispatch({
      type: types.GET_VERSION_HISTORY_LOGS,
      payload: {
        loader: false,
        error: true,
        message: errorMessage(err),
        data: null,
      },
    });
  }
};
